import { API_BASE_URL } from '../config/api';

export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
}

export interface TaroBotRequest {
  clientId: string;
  message: string;
  conversationHistory?: ChatMessage[];
}

export interface TaroBotDietitianRequest {
  dietitianId: string;
  message: string;
  conversationHistory?: ChatMessage[];
}

export interface TaroBotResponse {
  message: string;
  targetCalories: number;
  consumedCalories: number;
  remainingCalories: number;
}

export interface ErrorResponse {
  error: string;
}

export const taroBotApi = {
  async chat(request: TaroBotRequest): Promise<TaroBotResponse> {
    const response = await fetch(`${API_BASE_URL}/tarobot/chat`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });

    if (!response.ok) {
      const error: ErrorResponse = await response.json();
      throw new Error(error.error || `HTTP error! status: ${response.status}`);
    }

    return await response.json();
  },

  async chatDietitian(
    request: TaroBotDietitianRequest
  ): Promise<TaroBotResponse> {
    const response = await fetch(`${API_BASE_URL}/tarobot/chat/dietitian`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });

    if (!response.ok) {
      const error: ErrorResponse = await response.json();
      throw new Error(error.error || `HTTP error! status: ${response.status}`);
    }

    return await response.json();
  },
};
